const US = 'US';
const PS = 'PS';

export default {US, PS}